import { min } from 'ramda'

import toFixedValue, { fromFixedValue, toFixedValueInt } from 'app/common/lib/toFixedValue'


const convertToFixed = (limit: number | null) => {
  if (limit === null) return null
  return (limit % 1 ? toFixedValue(limit) : toFixedValueInt(limit))
}

const getLimit = (personalLimit: string | null, commonLimit: string | null) => {
  if (!personalLimit && !commonLimit) return null

  const personalLimitNumber = (personalLimit && fromFixedValue(personalLimit)) || 0
  const commonLimitNumber = (commonLimit && fromFixedValue(commonLimit)) || 0

  if (personalLimit && commonLimit) {
    return min(personalLimitNumber, commonLimitNumber)
  }
  return personalLimitNumber || commonLimitNumber
}


type Options = {
  personalLimit: string | null
  commonLimit: string | null
  splitLimitEnabled: boolean
  sellPointsPersonalLimits: Array<{ sellPointID: string; value: string | null }>
  sellPoints: Record<string, { ID: string, title: string }>
}

type SellPointLimitItem = {
  ID: string
  title: string
  value: string | null
}

type Limits = {
  limit: string | null | Array<SellPointLimitItem>
  personalLimit: string | null | Array<SellPointLimitItem>
  commonLimit: string | null
}

export function useLimits(options: Options): Limits {
  const {
    personalLimit,
    commonLimit,
    splitLimitEnabled,
    sellPointsPersonalLimits,
    sellPoints,
  } = options

  return {
    limit: (
      splitLimitEnabled
        ? sellPointsPersonalLimits.map(({
          sellPointID,
          value,
        }) => ({
          ID: sellPointID,
          title: sellPoints[sellPointID]?.title || '',
          value: convertToFixed(getLimit(value, commonLimit)),
        }))
        : convertToFixed(getLimit(personalLimit, commonLimit))
    ),
    personalLimit: (
      splitLimitEnabled
        ? sellPointsPersonalLimits.map(({
          sellPointID,
          value,
        }) => ({
          ID: sellPointID,
          title: sellPoints[sellPointID]?.title || '',
          value,
        }))
        : personalLimit
    ),
    commonLimit,
  }
}
